export default function AboutUs({ mode = "light" } = {}) {
  // const textColor = mode === "light" ? "dark" : "light";
  return (
    <>
      <div
        className="container-fluid"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/about_us_bg.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "90vh",
        }}
      >
        <div className={`pt-5 text-light`}>
          <h3>About Us</h3>
          <br></br>
          <p>This is a learning webiste to test the skills aquired.</p>
          <p>
            This website is built using github, javascript, html, css, react,
            aws-ec2-ubuntu, godaddy and more importantly by curiosity.
          </p>
        </div>
      </div>
    </>
  );
}
